"use client"

import { makeStyles } from "@mui/styles"
import Card from "@mui/material/Card"
import Box from "@mui/material/Box"
import Colors from "../../../common/Colors"
import Text from "../../../components/Text"
import StarIcon from "@mui/icons-material/Star" // Import the star icon for special items

const useStyles = makeStyles({
  cardContainer: {
    width: "100%", // Fixed the issue: Set width to 100%
    height: "80px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "12px 16px",
    backgroundColor: "#041A29",
    overflow: "hidden",
    cursor: "pointer",
    transition: "transform 0.2s ease, opacity 0.2s ease",
    "&:hover": {
      opacity: 0.9,
    },
  },
  contentWrapper: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  iconContainer: {
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
  },
  teapotIcon: {
    width: "24px",
    height: "24px",
    color: "#F44336",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    flexGrow: 1, // Allow text container to grow
  },
  price: {
    fontWeight: "bold",
    color: Colors.whiteColor,
    marginTop: "2px",
    fontSize: "1rem",
  },
  itemName: {
    fontSize: "1rem",
    lineHeight: "1.2",
    color: Colors.whiteColor,
    fontWeight: "500",
  },
  cardWrapper: {
    width: "100%",
    display: "flex", // Ensures proper alignment
    marginBottom: "16px", // Adds spacing between cards
  },
  foodImage: {
    width: "50px", // Set a fixed width for the image
    height: "50px", // Set a fixed height for the image
    objectFit: "cover", // Ensure the image covers the area
    borderRadius: "4px", // Optional: add border radius
    marginRight: "12px", // Add margin for spacing
  },
  specialBadge: {
    position: "absolute",
    top: "8px",
    right: "8px",
    backgroundColor: "#FFC857",
    color: "#02111B",
    borderRadius: "4px",
    padding: "2px 6px",
    fontSize: "0.7rem",
    fontWeight: "700",
    zIndex: 1,
  },
  specialIcon: {
    color: "#FFC857",
    marginLeft: "8px",
    fontSize: "1.2rem !important", // Add !important to ensure the size stays consistent
  },
  priceContainer: {
    display: "flex",
    alignItems: "center",
  }
})

function FoodCard({ item, addToCart, openSpecialProductModal }) {
  const { menu_type, menu_name, menu_price, menu_image, special_details, area_details } = item;
  const classes = useStyles();

  const hasSpecialDetails = special_details && (
    (special_details.detailseAttribute && special_details.detailseAttribute.length > 0) ||
    (special_details.detailseAddonFields && special_details.detailseAddonFields.length > 0)
  );

  const handleClick = () => {
    if (hasSpecialDetails && openSpecialProductModal) {
      openSpecialProductModal(item);
    } else {
      addToCart(item);
    }
  };

  const getEffectivePrice = () => {
    const activeArea = item.area_details?.find(area => area.area_status === true);
    return activeArea ? activeArea.area_final_price : item.menu_price;
  };

  const effectivePrice = getEffectivePrice();

  return (
    <div className={classes.cardWrapper}>
      <Card
        className={classes.cardContainer}
        onClick={handleClick}
        style={{
          backgroundColor: "#041A29",
          backgroundImage: "none",
          borderLeft:
            menu_type === "veg"
              ? "4px solid #4CAF50"
              : menu_type === "nonveg"
              ? "4px solid #F44336"
              : menu_type === "jain"
              ? "4px solid white"
              : menu_type === "eggetarian"
              ? "4px solid #FFC857"
               : menu_type === "drinks"
              ? "4px solid #4C91FF"
              : "4px solid gray",
          position: "relative",
        }}
      >
        <Box className={classes.contentWrapper}>
          <img
            src={menu_image || "/placeholder.svg"}
            alt={menu_name}
            className={classes.foodImage}
          />
          <Box className={classes.textContainer}>
            <Text className={classes.itemName} noSelect>
              {menu_name}
            </Text>
            <Box className={classes.priceContainer}>
              <Text className={classes.price}>₹{effectivePrice}</Text>
              {hasSpecialDetails && (
                <StarIcon className={classes.specialIcon} fontSize="small" />
              )}
            </Box>
          </Box>
        </Box>
      </Card>
    </div>
  );
}

export default FoodCard;